import { useState, useCallback } from 'react';
import { InputInsert, Insert } from '../types/mold';
import { InsertService } from '../services/api';

export const useInserts = () => {
  const [inserts, setInserts] = useState<Insert[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchInserts = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await InsertService.getInserts();
      setInserts(response.data);
    } catch (err) {
      setError('Failed to fetch inserts');
    } finally {
      setLoading(false);
    }
  }, []);

  const createInsert = async (data: InputInsert) => {
    try {
      setLoading(true);
      setError(null);
      const response = await InsertService.createInsert(data);
      await fetchInserts(); // Refresh list after creation
      return response.data; // Return the created insert
    } catch (err) {
      setError('Failed to create insert');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const updateInsert = async (id: number, data: InputInsert) => {
    try {
      setLoading(true);
      setError(null);
      await InsertService.updateInsert(id, data);
      await fetchInserts(); // Refresh list after update
    } catch (err) {
      setError('Failed to update insert');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { inserts, loading, error, retry: fetchInserts, createInsert, updateInsert, fetchInserts };
};
